// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2295":"5c3c494a79788e24","2329":"bb316c81c50a5d4c","8150":"6bd474ae5d36a8d4"}[chunkId] + ".css";
};